import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'friendlyTime' })
export class FriendlyTimePipe implements PipeTransform {
  transform(date: string): string {
    return moment.utc(date, 'hh:mm').format('hh:mm A');
  }
}
